var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.553 10.6824C16.553 13.3724 14.3724 15.553 11.6824 15.553C8.99242 15.553 6.81177 13.3724 6.81177 10.6824C6.81177 7.99242 8.99242 5.81177 11.6824 5.81177C14.3724 5.81177 16.553 7.99242 16.553 10.6824ZM14.2439 15.7561C13.4742 16.1454 12.6039 16.3648 11.6824 16.3648C8.5441 16.3648 6 13.8207 6 10.6824C6 7.5441 8.5441 5 11.6824 5C14.8207 5 17.3648 7.5441 17.3648 10.6824C17.3648 12.6086 16.4063 14.311 14.9403 15.3387L16.9502 18.5714L16.2608 19L14.2439 15.7561Z",
    fill: "#101010"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.7816ef82a83713f50c828513c9a74c1b.svg";
export { ForwardRef as ReactComponent };